import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import React, { Component } from 'react';
import { UserIcon, MessageIcon } from '~svg';
import { validation, validateForm } from '../../../../utils/validation';
import {
  Input,
  Button,
  TelephoneInput,
  ValidationMessage,
} from '../../../../component';
import { bookingApi } from '../../../../services/apis';
class IssuerContactInfo extends Component {
  state = {
    data: {
      firstName: '',
      lastName: '',
      mobile: '',
      email: '',
      loading: false,
    },
    countryAbr: 'ir',
    errors: {},
  };

  validate = () => {
    const { firstName, lastName, mobile, email } = this.state.data;
    const { error, result } = validateForm({
      firstName: validation.string(firstName).required().errors,
      lastName: validation.string(lastName).required().errors,
      mobile: validation.phone(mobile).required().errors,
      email: validation.email(email).required().errors,
    });

    return { result, error };
  };

  componentDidMount() {
    let {
      firstName,
      lastName,
      mobile,
      email,
      countryAbr = 'ir',
    } = this.props.contactInfo;
    this.setState(
      {
        data: { firstName, lastName, mobile, email },
        countryAbr,
      },
      () => {
        let { error } = this.validate();
        this.setState({ errors: error });
      },
    );
  }

  //update booking with contact info
  doSubmit = () => {
    let { id } = this.props;
    let { firstName, lastName, email, mobile } = this.state.data;
    let standardMobile = mobile.toString().replace(/[-()\s]/g, '');
    this.setState({ loading: true });
    bookingApi
      .insert({
        data: {
          _id: id,
          moneyUnit: this.props.moneyUnit,
          issuerContactInfo: {
            firstName,
            lastName,
            mobile: standardMobile.replace(/\s/g, ''),
            email,
            address: '',
            countryAbr: this.state.countryAbr,
          },
        },
      })
      .then((result) => {
        this.props.fetchBookingData();
        this.props.updatechangeContact();
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  //handle input for phone component
  handleTelephoneInput = (value) => {
    let { data } = this.state;
    data.mobile = value.fullNumber.replaceAll(' ', '');
    this.setState({ data, countryAbr: value.country.toLowerCase() }, () =>
      this.setState({
        errors: {
          ...this.state.errors,
          mobile: this.validate().error.mobile,
        },
      }),
    );
    // this.setState({ dialCode: value.code });
  };

  render() {
    let { countryAbr, data } = this.state;
    return (
      <div style={{ zIndex: 1000 }}>
        <form
          id="issue-contact-form"
          name="issue-contact-form"
          onSubmit={this.handleSubmit}
          className="w-100"
        >
          <div className="col-md-12 col p-0 pt-1 ">
            <Input
              name={'firstName'}
              value={data?.firstName}
              label={this.props.intl.formatMessage({
                id: 'booking.firstname',
              })}
              onChange={(event) => {
                this.setState(
                  {
                    data: { ...this.state.data, firstName: event.target.value },
                  },
                  () =>
                    this.setState({
                      errors: {
                        ...this.state.errors,
                        firstName: this.validate().error.firstName,
                      },
                    }),
                );
              }}
              className={''}
              inputClassName={'bg-third-light'}
              language={this.props.language}
              outSideLabel={true}
              outSideLabelClass={'text-start text-dark'}
              outSideLabelPosition={'top'}
              iconUrl={
                <UserIcon
                  color="#4c54b9"
                  variant="svg-smaller svg-xs-small svg-sm-large"
                />
              }
            />

            <ValidationMessage errors={this.state?.errors?.firstName} />
          </div>
          <div className={`col-md-12 col p-0 pt-1 `}>
            <Input
              name={'lastName'}
              value={data?.lastName}
              label={this.props.intl.formatMessage({
                id: 'user.lastname',
              })}
              onChange={(event) => {
                this.setState(
                  {
                    data: { ...this.state.data, lastName: event.target.value },
                  },
                  () =>
                    this.setState({
                      errors: {
                        ...this.state.errors,
                        lastName: this.validate().error.lastName,
                      },
                    }),
                );
              }}
              className={''}
              inputClassName={'bg-third-light'}
              language={this.props.language}
              outSideLabel={true}
              outSideLabelClass={'text-start text-dark'}
              outSideLabelPosition={'top'}
              iconUrl={
                <UserIcon
                  color="#4c54b9"
                  variant="svg-smaller svg-xs-small svg-sm-large"
                />
              }
            />
            <ValidationMessage errors={this.state?.errors?.lastName} />
          </div>
          <div className="col-md-12 col p-0 pt-1">
            <Input
              name={'email'}
              value={data?.email}
              label={this.props.intl.formatMessage({
                id: 'user.email',
              })}
              onChange={(event) => {
                this.setState(
                  {
                    data: { ...this.state.data, email: event.target.value },
                  },
                  () =>
                    this.setState({
                      errors: {
                        ...this.state.errors,
                        email: this.validate().error.email,
                      },
                    }),
                );
              }}
              className={''}
              inputClassName={'bg-third-light'}
              language={this.props.language}
              outSideLabel={true}
              outSideLabelClass={'text-start text-dark'}
              outSideLabelPosition={'top'}
              iconUrl={
                <MessageIcon
                  color="#4c54b9"
                  variant="svg-smaller svg-xs-small svg-sm-large"
                />
              }
            />
            <ValidationMessage errors={this.state?.errors?.email} />
          </div>
          <div className="d-flex  align-items-center w-100 my-2">
            <div className="d-flex flex-column align-items-center w-100 ">
              <label className="px-3  align-self-start text-dark">
                <FormattedMessage
                  id="user.phone"
                  children={(msg) => <>{msg}</>}
                />
              </label>
              <TelephoneInput
                onChange={(e) => this.handleTelephoneInput(e)}
                telephoneNumber={data?.mobile}
                countryAbr={countryAbr}
                name={'mobile'}
                // value={this.state.data.mobile}
              />
              <ValidationMessage errors={this.state?.errors?.mobile} />
            </div>
          </div>
          <div className="d-flex col-12 justify-content-center p-0 text-center mb-3 mt-0 ">
            <Button
              id="issue-contact-submit"
              name="issue-contact-submit"
              onClick={this.doSubmit}
              className="btn-secondary"
              label={this.props.intl.formatMessage({
                id: 'booking.change',
              })}
              disabled={!this.validate().result}
              type="button"
              loading={this.state.loading}
            />
          </div>
        </form>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps, {})(IssuerContactInfo));
